// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Adz_","inner":"Footer_inner__duTpy"};